import { apiSlice } from "./apiSlice";

export const verifyEmailApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    verifyEmail: builder.mutation({
      query: body => ({
        url:"/api/v3/crm/passwords/send_otp",
        method: "POST",
        body: JSON.parse(JSON.stringify(body)),
      }),
    }),
  }),
});

export const {useVerifyEmailMutation} = verifyEmailApiSlice;

